import { render } from "./TestSmsForm.vue?vue&type=template&id=9ea11e4a"
import script from "./TestSmsForm.vue?vue&type=script&lang=js"
export * from "./TestSmsForm.vue?vue&type=script&lang=js"

import "./TestSmsForm.vue?vue&type=style&index=0&id=9ea11e4a&lang=css"

import exportComponent from "/codebuild/output/src1551863306/src/git-codecommit.ap-northeast-2.amazonaws.com/v1/repos/m2g-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__